import { platformAPI } from '@/utils/api';
import {
  isTiktokShopAuthorized,
  normalizeTiktokShopType,
} from '@/tiktok-platform/constants/tiktokRoutes';

export const TIKTOK_SHOP_AUTH_EXPIRED_MESSAGE = '店铺授权已过期，请先在平台管理完成授权后再进入';

/**
 * 当前工作区已授权的 TikTok 店铺列表（走 platform API，门禁解锁前可用）。
 * @param {{ shopType?: string }} [options]
 */
export async function listAuthorizedTiktokShops(options = {}) {
  const list = await platformAPI.listShops();
  const shops = Array.isArray(list) ? list : [];
  const filterType = normalizeTiktokShopType(options.shopType);

  return shops.filter((shop) => {
    if (String(shop?.platformCode || '').toUpperCase() !== 'TIKTOK') return false;
    if (!isTiktokShopAuthorized(shop)) return false;
    if (filterType && normalizeTiktokShopType(shop?.shopType) !== filterType) return false;
    return true;
  });
}

/** 当前工作区是否存在已授权 TikTok 店铺。 */
export async function hasAuthorizedTiktokShop(options = {}) {
  const shops = await listAuthorizedTiktokShops(options);
  return shops.length > 0;
}
